// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__fbhWX","description":"MealItem_description__7BojC","price":"MealItem_price__Arq2M"};